import NumberInput from '@/common/atoms/NumberInput'
import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const minProposalDurationDays = 1
export const maxProposalDurationDays = 365

interface Props {
  value: number
  onChange: (days: number) => void
  onBlur?: () => void
  isDisabled?: boolean
}

// The same duration for every proposal of the org: a known rule of the game,
// rather than a deadline chosen proposal by proposal by its author.
export default function ProposalDurationInput({
  value,
  onChange,
  onBlur,
  isDisabled,
}: Props) {
  const { t } = useTranslation()

  return (
    <Flex alignItems="center">
      <NumberInput
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isDisabled={isDisabled}
        min={minProposalDurationDays}
        max={maxProposalDurationDays}
        maxW="110px"
      />
      <Text ml={3}>{t('OrgEditModal.proposalDurationUnit')}</Text>
    </Flex>
  )
}
